import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const RETRIEVED_AGENTS = "RETRIEVED_AGENTS";
export const RETRIEVED_AGENT = "RETRIEVED_AGENT";
export const RETRIEVED_AGENT_CHAT_SESSIONS = "RETRIEVED_AGENT_CHAT_SESSIONS";
export const RETRIEVED_AGENT_MEDIA = "RETRIEVED_AGENT_MEDIA";
export const RETRIEVED_AGENT_SUPPORTING_CONTENT =
  "RETRIEVED_AGENT_SUPPORTING_CONTENT";
export const AGENT_ERROR = "AGENT_ERROR";
export const SAVING_AGENT = "SAVING_AGENT";
export const SAVING_MEDIA = "SAVING_MEDIA";
export const SAVING_SUPPORTING_CONTENT = "SAVING_SUPPORTING_CONTENT";
export const SAVED_AGENT = "SAVED_AGENT";
export const CLEAR_SAVED_AGENT = "CLEAR_SAVED_AGENT";
export const CLEAR_SAVED_MEDIA = "CLEAR_SAVED_MEDIA";
export const CLEAR_SAVED_SUPPORTING_CONTENT = "CLEAR_SAVED_SUPPORTING_CONTENT";
export const RETRIEVED_MEDIA = "RETRIEVED_MEDIA";
export const RETRIEVED_SUPPORTING_CONTENT = "RETRIEVED_SUPPORTING_CONTENT";
export const ADD_CHAT_SESSION = "ADD_CHAT_SESSION";
export const DELETE_CHAT_SESSION = "DELETE_CHAT_SESSION";
export const DELETE_MEDIA = "DELETE_MEDIA";
export const DELETE_SUPPORTING_CONTENT = "DELETE_SUPPORTING_CONTENT";

export const addChatSession = (chatSession) => {
  return {
    type: ADD_CHAT_SESSION,
    chatSession: chatSession,
  };
};

const agentError = (error) => {
  return {
    type: AGENT_ERROR,
    error: error,
  };
};

const savingAgent = (saving) => {
  return {
    type: SAVING_AGENT,
    saving: saving,
  };
};

const savingMedia = (saving) => {
  return {
    type: SAVING_MEDIA,
    saving: saving,
  };
};

const savingSupportingContent = (saving) => {
  return {
    type: SAVING_SUPPORTING_CONTENT,
    saving: saving,
  };
};

export const deleteAgentChatSession = (chatSessionID) => {
  return {
    type: DELETE_CHAT_SESSION,
    chatSessionID: chatSessionID,
  };
};

export const deleteAgentMedia = (mediaID) => {
  return {
    type: DELETE_MEDIA,
    mediaID: mediaID,
  };
};

export const deleteAgentSupportingContent = (supportingContentID) => {
  return {
    type: DELETE_SUPPORTING_CONTENT,
    supportingContentID: supportingContentID,
  };
};

export const clearAgent = () => {
  return {
    type: RETRIEVED_AGENT,
    agent: null,
  };
};

export const clearSavedAgent = () => {
  return {
    type: CLEAR_SAVED_AGENT,
  };
};

export const getAgent = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/agent/${public_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((agent) => {
        dispatch({
          type: RETRIEVED_AGENT,
          agent: agent,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const getAgentSupportingContent = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(
      `${config.REST_SERVER_URL}/admin/agent/${public_id}/supportingcontent`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    )
      .then((response) => response.json())
      .then((supportingContent) => {
        dispatch({
          type: RETRIEVED_AGENT_SUPPORTING_CONTENT,
          agentSupportingContent: supportingContent,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const getAgentMedia = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/agent/${public_id}/media`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((media) => {
        dispatch({
          type: RETRIEVED_AGENT_MEDIA,
          agentMedia: media,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const getAgentChats = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/agent/${public_id}/chats`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((chatSessions) => {
        dispatch({
          type: RETRIEVED_AGENT_CHAT_SESSIONS,
          agentChatSessions: chatSessions,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const getAgents = () => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/agent`, {
      method: "GET",
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((agents) => {
        dispatch({
          type: RETRIEVED_AGENTS,
          agents: agents,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const saveAgent = (agent) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    dispatch(savingAgent(true));
    const method = agent.id ? "PUT" : "POST";
    const url = agent.id
      ? `${config.REST_SERVER_URL}/admin/agent/${agent.public_id}`
      : `${config.REST_SERVER_URL}/admin/agent`;
    fetch(url, {
      method: method,
      crossDomain: true,
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
      body: JSON.stringify(agent),
    })
      .then((response) => response.json())
      .then((agent) => {
        dispatch({
          type: SAVED_AGENT,
          savedAgent: agent,
        });

        // For now, just reload the agents
        dispatch(getAgent(agent.public_id));
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      )
      .finally(() => {
        dispatch(savingAgent(false));
      });
  };
};

export const clearSavedMedia = () => {
  return {
    type: CLEAR_SAVED_MEDIA,
  };
};

export const clearSavedSupportingContent = () => {
  return {
    type: CLEAR_SAVED_SUPPORTING_CONTENT,
  };
};

export const saveMedia = (
  mediaForm,
  agent_id,
  onSuccess = () => {},
  onFail = () => {}
) => {
  return (dispatch) => {
    dispatch(savingMedia(true));
    fetch(`${config.REST_SERVER_URL}/admin/agent/${agent_id}/media`, {
      method: "POST",
      headers: {
        "X-Access-Token": getIDToken(),
      },
      body: new FormData(mediaForm),
    })
      .then((response) => response.json())
      .then((media) => {
        onSuccess(media);
      })
      .catch((error) => {
        console.error("Error!!! ", error);
        onFail(error);
      })
      .finally(() => {
        dispatch(savingMedia(false));
      });
  };
};

export const getMedia = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/agent/media/${public_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((media) => {
        dispatch({
          type: RETRIEVED_MEDIA,
          media: media,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const deleteChatSession = (chat_session_id, cb = () => {}) => {
  return (dispatch) => {
    fetch(`${config.REST_SERVER_URL}/admin/chat/session/${chat_session_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then(() => {
        dispatch(deleteAgentChatSession(chat_session_id));
        cb();
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const deleteSupportingContent = (
  supporting_content_id,
  cb = () => {}
) => {
  return (dispatch) => {
    fetch(
      `${config.REST_SERVER_URL}/admin/supportingcontent/${supporting_content_id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    )
      .then((response) => response.json())
      .then(() => {
        dispatch(deleteAgentSupportingContent(supporting_content_id));
        cb();
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const generateSupportingContent = (
  supporting_content_id,
  cb = () => {}
) => {
  return (dispatch) => {
    fetch(
      `${config.REST_SERVER_URL}/admin/supportingcontent/${supporting_content_id}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    )
      .then((response) => response.json())
      .then(() => {
        cb();
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const deleteMedia = (media_id, cb = () => {}) => {
  return (dispatch) => {
    dispatch(deleteAgentMedia(media_id));
    fetch(`${config.REST_SERVER_URL}/admin/media/${media_id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then(() => {
        dispatch(deleteAgentMedia(media_id));
        cb();
      })
      .catch((error) => {
        console.error("Error!!! ", error);
      });
  };
};

export const saveSupportingContent = (supportingContent, agent_id) => {
  return (dispatch) => {
    dispatch(savingSupportingContent(true));
    const method = supportingContent.id ? "PUT" : "POST";
    fetch(
      `${config.REST_SERVER_URL}/admin/agent/${agent_id}/supportingcontent`,
      {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
        body: JSON.stringify(supportingContent),
      }
    )
      .then((response) => response.json())
      .then((supportingContent) => {})
      .finally(() => {
        dispatch(savingSupportingContent(false));
      });
  };
};

export const getSupportingContent = (public_id) => {
  return (dispatch) => {
    // We dispatch requestLogin to kickoff the call to the API
    //dispatch(requestLogin(creds));
    fetch(`${config.REST_SERVER_URL}/admin/supportingcontent/${public_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    })
      .then((response) => response.json())
      .then((supportingContent) => {
        dispatch({
          type: RETRIEVED_SUPPORTING_CONTENT,
          supportingContent: supportingContent,
        });
      })
      .catch((error) =>
        dispatch(agentError(`Something was wrong. Try again: ${error}`, false))
      );
  };
};

export const downloadSupportingContent = async (public_id, title) => {
  try {
    const response = await fetch(
      `${config.REST_SERVER_URL}/admin/supportingcontent/${public_id}/json`,
      {
        method: "GET",
        crossDomain: true,
        headers: {
          "Content-Type": "application/json",
          "X-Access-Token": getIDToken(),
        },
      }
    );

    const data = await response.json();
    if (!data.success) {
      throw new Error(data.message);
    }

    const blob = new Blob([JSON.stringify(data.supporting_content_items)], {
      type: "text/json",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = `${title}.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("There was an error downloading the file:", error);
  }
};
